import "./styles.css";
export { VuetifyView } from "./VuetifyView";
export * from "./generated";
export { HtmlModel } from "./Html";
export { VuetifyTemplateModel } from "./VuetifyTemplate";
export { ThemeModel, ThemeColorsModel } from "./Themes";
export const {
  version
} = require("../package.json"); // eslint-disable-line global-require